export default {
  URL_GET_CREATE_ISSUE_METADATA: '/rest/api/2/issue/createmeta',
};
